
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq1mZPpg9E7TqecmnsBr2qDVXzC4VyNKIcCkGCkM0t8ugMeta } from "/codebuild/output/src4200877996/src/src/pages/faq.vue?macro=true";
import { default as menu8aY9BJhXMin3UplyZiPxWMCMPCoXE67kJVfz8FiA27AMeta } from "/codebuild/output/src4200877996/src/src/pages/menu.vue?macro=true";
import { default as indexhultyC_3harhxmTnwDos98850m3IP9CezvGyqNQFZAkMeta } from "/codebuild/output/src4200877996/src/src/pages/index.vue?macro=true";
import { default as contact3ZIio0Enq_2o7PmEB_WSdIXUV4OdpftvKswFeVmKrdoMeta } from "/codebuild/output/src4200877996/src/src/pages/contact.vue?macro=true";
import { default as tutorialzbwxhqmHLSGR5iqdZtzxVuDvt0n0_cXJT5LM28Ijw48Meta } from "/codebuild/output/src4200877996/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_45OXdJk0jF_ETVNwtWzR243Lkm0vP08upC6gEh6zwZPwMeta } from "/codebuild/output/src4200877996/src/src/pages/agreement.vue?macro=true";
import { default as about_45passILs7V3vj5_45kQMWxxpfR4OovqLz_45KGsH9mvNSeDWSJPoMeta } from "/codebuild/output/src4200877996/src/src/pages/about-pass.vue?macro=true";
import { default as indexFTKjXpNxLsWI2eDmiBtA_wuqo0UAyudDenRFPEri2D8Meta } from "/codebuild/output/src4200877996/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93O99MoX1nbn7H8UvML6JDaI_RJLuOBhsspV3UpPbNtGQMeta } from "/codebuild/output/src4200877996/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance68ux3HgzR7zs0u78Wz1CU3nX6VPl_457gVUl4Vh_45ZoHBMMeta } from "/codebuild/output/src4200877996/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93SyVhESyarB7AJEN4fEdxCnQWfaoM0hUXBEENhckaKqwMeta } from "/codebuild/output/src4200877996/src/src/pages/notice/[id].vue?macro=true";
import { default as indexbAtMzjVQ0G3pu0Ebedhlm4ZhM_NIGwoPQSQLy1G30WUMeta } from "/codebuild/output/src4200877996/src/src/pages/coupon/index.vue?macro=true";
import { default as index_45O8bZCvk33USd9zFa88s9io8Hv42gYAt3BfCbuOc0I8Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/index.vue?macro=true";
import { default as indexzQ_8i8akL8qZXTi2JN7CKqhqo1O5pJjIaUGmAtoBuC4Meta } from "/codebuild/output/src4200877996/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93LuuSKDe88Pt6WoEg0ENRvP7FWg_4568EFD5W0fW_45bO0McMeta } from "/codebuild/output/src4200877996/src/src/pages/parking/[id].vue?macro=true";
import { default as indexZzpnfyVnL4qqigvxrJxrtVzARE8AkwujDl9AQxrhFPQMeta } from "/codebuild/output/src4200877996/src/src/pages/history/index.vue?macro=true";
import { default as index9yo1c0QOcllv6JHoI4ynQpZXzB1M9GiQmr8o0VSHA2AMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/index.vue?macro=true";
import { default as indexBQPKfqxKUCtJCn5ugODFIyuRcPFkOTzzf3h24C7PP_YMeta } from "/codebuild/output/src4200877996/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexCXZ1ug4sPFYJ26Dc_ZqNnkIywRFAIV_aYHJckxr7U_45sMeta } from "/codebuild/output/src4200877996/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviyKwE_frqGLykxRloDos_W6I2S1wwg9qAWM6wyeO1ZssMeta } from "/codebuild/output/src4200877996/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editith9b2y1yrS8ftHme663U3BPSNnsEGYSLZKvL8giYbQMeta } from "/codebuild/output/src4200877996/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement9HFeT64sSLDo9Ouq2HVCCnfFBsixQFh97GLhcOeUIXIMeta } from "/codebuild/output/src4200877996/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexzWsmy3j0muY8fMRzQeLitTQ6i1rhnJsLLLfG6bQBWHYMeta } from "/codebuild/output/src4200877996/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dz9HMb0N1UGmXYmFyCO0LyoVJB7cnNQH3CHhz5GaN7wsMeta } from "/codebuild/output/src4200877996/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmu6fUrwHJDK62ddvG676qVWvWFpEVhM3vg3BRdBllGn4Meta } from "/codebuild/output/src4200877996/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index4mHOiGOWqkZFeihJq3w1yhFQfaD3_45CcUHikdMawguj4Meta } from "/codebuild/output/src4200877996/src/src/pages/card/create/index.vue?macro=true";
import { default as indexG8FWBmSZg3Mwq9UrHNzIsT_45as_455ZZikCfNqYjwxo33YMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmBYVoGIqcakCt1XcyAYj9iD1uXNucsRZPbMnjkq0KjekMeta } from "/codebuild/output/src4200877996/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmp8ZTZUaC9fXQ6zXu_45Ffen3q6xdMXUIg8Pt_455Jprrob0Meta } from "/codebuild/output/src4200877996/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeC_45VXQ3r2pKDVY6WP2KnKEUIpnzKRe3y4ioUK2BQjsPMMeta } from "/codebuild/output/src4200877996/src/src/pages/membership/complete.vue?macro=true";
import { default as register7bH6XP1yXoEKUt7yC9oirqWRPI4fLhiTmxQHChkvEDcMeta } from "/codebuild/output/src4200877996/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93s2nza8DgYFKWsD4PDW8nsMg6gTXu0zIoi0xlSbru7zMMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmNVbRWtOWa7t3utLmzH1yWaQhkuGuGthBiBpVKbJg4HoMeta } from "/codebuild/output/src4200877996/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_935NELIdUQCzJBxLBGkx1BpoeE6W_45DZv_QtDr_45NnYzLTQMeta } from "/codebuild/output/src4200877996/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexu9qACe75ghEfD9aL_LEnujZwSw9Ae6jnRKNU0jnLWNYMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codePRe4Lp8chblRds_dlPYWxXjd1_45teuwl4rle9y4IMdGgMeta } from "/codebuild/output/src4200877996/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codey8F2AXHpzFSq09HfRjfBWuJz9D61B_451mWcMwWZ_455jNkMeta } from "/codebuild/output/src4200877996/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeZ4EPGzautHetpV70zCdMXj7v_ZrybCphY4fY_45DzODrcMeta } from "/codebuild/output/src4200877996/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register2ifw8IuNDKht0erXB_45SacZjI5QcygP8zupUjZv9_GrIMeta } from "/codebuild/output/src4200877996/src/src/pages/contact-form/register.vue?macro=true";
import { default as completetfspgAqvXiKXL0xRof0tNOnOnVY6gGJJp6rQyj5QBcQMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexCAlMm6cDGTHj5MZeZgFihWWw0XmO8u7GjdtGD90vf5AMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmz4HrUZtZzkHlwW_45a3wSelIWbijJ_y_bG99VaMAomCn4Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeh85OV51nV4zr3hyCV9FRcaPJX4f4RmqlbeXn6vsuqKsMeta } from "/codebuild/output/src4200877996/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexo_q5rWZSwutymzYOzj_xzrw3cAHVL7EBRiXnjv9OoKgMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93HgeDflqF1wt8J5FLuThEJzDsRG1JDAUQWBqD7sLSnWkMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completehGtGFII_zz2J_45emy9V9_aQYiAGHJNMuW59X8H8h3ohkMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliashsXdJkdILZDG61V9ioBYsrFB4IHrwwntdHSlXn37aOgMeta } from "/codebuild/output/src4200877996/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleY9CFd7_3um1cW_45EJHydfWUSIeTV71GuWJ8JMWRHaEwgMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailcgKKxyDaMIzaP7pmVk3IF0WCl8DVFOpWjpkXtIwLHKQMeta } from "/codebuild/output/src4200877996/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm7s6pYcH0e23yzGRZm6yJLBjMJb6_45ZxjL5rmuUrAj8PkMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentOC1b9haYY_cBZP3hnG5b6X9Yoc9Xu0NbzlDNDjq6TloMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirma2vd0nR61fxkWdnQaPyNKXu7jityMawle7OzXRBsmFIMeta } from "/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatez0ixZBtutA6o_45x5NL7Arzu1yWItOHclq0tgwb3ORTDwMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completewg4BC_DnQSHp1Yz8SKM0EqX6BE2nz8BprwpmtYDRgDEMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeecgZYyOwvASVABflXCarBkNR5xHhGmg1aOmqZq0P1MUMeta } from "/codebuild/output/src4200877996/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordZ69gGavoDA9g2y1SpCWszDsPLIn694yVT_Uht_aMIdoMeta } from "/codebuild/output/src4200877996/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasc8al_45Te_45b18zc4ZxOsE2yvbYcmhBawuHjuozSRGfxMIMeta } from "/codebuild/output/src4200877996/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerUHJiBTOf6h1SPTAGsbWp5R0zmf8gs302WaNnaGKmT7kMeta } from "/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codec_45YkpjGvhNVlgb_A4D6R9_45wCiFq7bqBj_45VtK2XkNlE8Meta } from "/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexYhHR0jk1ZAlZ8wgUW2l3EhlB1EkiuqrOuOyxXMKv4mkMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexObTdfONp0INS0u95XPr4Fw744mY_Tnehp31swQ6soZYMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index2qeNHWZbK2b95uEpdRNoQdtprtF9ftpJsEOFOUVHWHwMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexCs4kQoFxLPirxCsrGy0wC_M5rYFSf1I2XuluLmu_45tl0Meta } from "/codebuild/output/src4200877996/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update75vMqpxj5LYZJ1bf1xSK8yAyLUmTRXLy6Y_45Zfcz5t3MMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete1dG_45w2je9M20vVzgf3FoiD0HlC7bJyZxz8CMvfi8Jh4Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm_45uFX_9tRpaX5GD0yZT6f0RxqBeunutsfVqQQCtRtGAcMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexACvqgYpKqIhFUkkPuK44bEDH_45gd2DmQt3LeurH59EKcMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeFnYyseK3Pev42LmTMO7LT_45X4VvKIbNTTlQs7Qh1F624Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update6eZdgE5dS9VesPO0qb7hOiNfN_45wY5e_45Pc43cLWgerUUMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexz2Iw5v2wGIm_Rz9AaqErKAzzBN8GZN31sE1_45o4RZaaoMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexhKtjnw4REzRFbOzwGBPC2a3GYAdlGhKzj6QYwbG9YbYMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeDEoxlfvYy7nPZMfhtgZIneugEbHQm7MLrKGl7iX45BAMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexltO7OpTmqunVjP5piiC5Ex_k8cpALjRHB0r1a_azLQkMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code6yv_45vgVU6_jFQfjd1rRs1ZCo7owJuPO1L6z_45SsWu_454oMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexJC4EqpXrqFKNRVuea7xn9nb4w3c0GKQE3n2iLf18MlsMeta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexZAa6w_45jZ8eUtFxRPqLuJeGeUw_P8atf6umpfe17TbdgMeta } from "/codebuild/output/src4200877996/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexB41mf1Z4NdT1lc5YkuKcnbO9BI_1v00iax4QXFIHfJ0Meta } from "/codebuild/output/src4200877996/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatebYihZJ6Nv7YYo5aKFLrE362B6wFVyFDMCG1LGoDGIq4Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmXpFunCqxFJF02jbx2Nl_452g3eEn_45ly17X1PMDw6tVb10Meta } from "/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu8aY9BJhXMin3UplyZiPxWMCMPCoXE67kJVfz8FiA27AMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexhultyC_3harhxmTnwDos98850m3IP9CezvGyqNQFZAkMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexbAtMzjVQ0G3pu0Ebedhlm4ZhM_NIGwoPQSQLy1G30WUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexZzpnfyVnL4qqigvxrJxrtVzARE8AkwujDl9AQxrhFPQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexBQPKfqxKUCtJCn5ugODFIyuRcPFkOTzzf3h24C7PP_YMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexCXZ1ug4sPFYJ26Dc_ZqNnkIywRFAIV_aYHJckxr7U_45sMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index4mHOiGOWqkZFeihJq3w1yhFQfaD3_45CcUHikdMawguj4Meta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmBYVoGIqcakCt1XcyAYj9iD1uXNucsRZPbMnjkq0KjekMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmp8ZTZUaC9fXQ6zXu_45Ffen3q6xdMXUIg8Pt_455Jprrob0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeC_45VXQ3r2pKDVY6WP2KnKEUIpnzKRe3y4ioUK2BQjsPMMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register7bH6XP1yXoEKUt7yC9oirqWRPI4fLhiTmxQHChkvEDcMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmNVbRWtOWa7t3utLmzH1yWaQhkuGuGthBiBpVKbJg4HoMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codePRe4Lp8chblRds_dlPYWxXjd1_45teuwl4rle9y4IMdGgMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codey8F2AXHpzFSq09HfRjfBWuJz9D61B_451mWcMwWZ_455jNkMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeZ4EPGzautHetpV70zCdMXj7v_ZrybCphY4fY_45DzODrcMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register2ifw8IuNDKht0erXB_45SacZjI5QcygP8zupUjZv9_GrIMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmz4HrUZtZzkHlwW_45a3wSelIWbijJ_y_bG99VaMAomCn4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeh85OV51nV4zr3hyCV9FRcaPJX4f4RmqlbeXn6vsuqKsMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexo_q5rWZSwutymzYOzj_xzrw3cAHVL7EBRiXnjv9OoKgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completehGtGFII_zz2J_45emy9V9_aQYiAGHJNMuW59X8H8h3ohkMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleY9CFd7_3um1cW_45EJHydfWUSIeTV71GuWJ8JMWRHaEwgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailcgKKxyDaMIzaP7pmVk3IF0WCl8DVFOpWjpkXtIwLHKQMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm7s6pYcH0e23yzGRZm6yJLBjMJb6_45ZxjL5rmuUrAj8PkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentOC1b9haYY_cBZP3hnG5b6X9Yoc9Xu0NbzlDNDjq6TloMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirma2vd0nR61fxkWdnQaPyNKXu7jityMawle7OzXRBsmFIMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completewg4BC_DnQSHp1Yz8SKM0EqX6BE2nz8BprwpmtYDRgDEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeecgZYyOwvASVABflXCarBkNR5xHhGmg1aOmqZq0P1MUMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordZ69gGavoDA9g2y1SpCWszDsPLIn694yVT_Uht_aMIdoMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerUHJiBTOf6h1SPTAGsbWp5R0zmf8gs302WaNnaGKmT7kMeta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codec_45YkpjGvhNVlgb_A4D6R9_45wCiFq7bqBj_45VtK2XkNlE8Meta || {},
    component: () => import("/codebuild/output/src4200877996/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4200877996/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]